export function isDefined(value: any): boolean {
  return value !== null && value !== undefined;
}

export function isDebug() {
  return process.env.VUE_APP_ENABLE_DEBUG === 'true';
}

export function debugLog(log: any) {
  if (isDebug()) {
    console.log(log);
  }
}

export function deepCopy(value: any): any {
  return JSON.parse(JSON.stringify(value));
}

export function scrollToTop() {
  const root = document.getElementById('egcf-main');
  if (isDefined(root)) {
    window.scrollTo({top: getOffsetTop(root), behavior: "smooth"});
  }
}


export function getOffsetTop(elem) {
  const clientRect = elem.getBoundingClientRect();
  return clientRect.top + document.documentElement.scrollTop;
}
